class ScrollTo {
    constructor() {
        window.scrollToElement = function(selector, options) {
            window.scrollTo({
                top: document.querySelector(selector).getBoundingClientRect().top + window.pageYOffset + (options.offset ? options.offset : 0),
                behavior: "smooth"
            });
        }
    }
}

export default ScrollTo;
